import { ICellRendererParams } from 'ag-grid-community';

export function AgGridPinnedRowCellRenderer(params: ICellRendererParams) {
    const colMetadata: Compliance.EntityImportMappingColDefMetadata = params.colDef['ws'];
    return `<div class="pinned-cell">${(colMetadata && colMetadata.isStatic) ? 'Static Column' : (params.value || '-')}</div>`;
}
